import { useHistory } from "react-router-dom";
import { PS_URLS, useCompanyId } from "../../core";
import { EnergyDeviceVendorsIntegration } from "../integrations/energy-devices/EnergyDeviceVendorsIntegration";
import { ICP4OnboardingWorkflowContainer } from "./ICP4OnboardingWorkflowContainer";
import { useEffect, useState } from "react";
import { getLinkedVendors } from "../integrations/energy-devices/energy-device-oems.client";
import { useMessages } from "../../ui/MessagesProvider";

export function ICP4VendorsIntegration() {
  const companyId = useCompanyId();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [hasSomeLinkedVendors, setHasSomeLinkedVendors] = useState(false);
  const {clear, error} = useMessages();

  useEffect(() => {
    async function load() {
      clear();
      setIsLoading(true);
      const linkedVendors = await getLinkedVendors(companyId);
      setHasSomeLinkedVendors(linkedVendors.length > 0);
      setIsLoading(false);
    }
    load().catch(e => error(e.message));
  }, [companyId]);

  return <ICP4OnboardingWorkflowContainer heading="Integrate Energy Devices" subHeading="Connect your solar inverters to automatically sync data and monitor performance."
  nextButtonProps={{
    disabled: isLoading || !hasSomeLinkedVendors,
    disabledText: hasSomeLinkedVendors ? (isLoading ? "Loading..." : "Something is wrong please contact support") : "Please integrate at least one vendor to continue",
    onClick: () => {
      history.push(`${PS_URLS(companyId).icp4ProjectsConfiguration()}`);
    }
  }}
  >
    <EnergyDeviceVendorsIntegration companyId={companyId} renderHeader={false} />
  </ICP4OnboardingWorkflowContainer>
}